import logo from "./logo.svg";
import "./App.css";
import "../src/scss/custom.scss";
import "../src/scss/responsive.scss";
import Step0 from "./steps/step0";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Step3 from "./steps/step3";
import Step4 from "./steps/step4";
import Step5 from "./steps/step5";
import Step6 from "./steps/step6";
import Step7 from "./steps/step7";
import Step71 from "./steps/step7.1";
import Step72 from "./steps/step7.2";
import Step73 from "./steps/step7.3";
import Step8 from "./steps/step8";
import Step9 from "./steps/step9";
import { useEffect, useState } from "react";
import Thankyou from "./steps/thankyou";
import NoPage from "./steps/NoPage";
import classNames from "classnames";



function App() {
  const [step, setStep] = useState(0);
  const [step1status, setStep1Status] = useState(false);
  const [step2status, setStep2Status] = useState(false);
  const [step3status, setStep3Status] = useState(false);
  const [step4status, setStep4Status] = useState(false);
  const [step5status, setStep5Status] = useState(false);
  const [step6status, setStep6Status] = useState(false);
  const [step7status, setStep7Status] = useState(false);
  const [step8status, setStep8Status] = useState(false);
  const [step9status, setStep9Status] = useState(false);
  // const [step1status, setStep1Status] = useState(false);

  const [formData, setFormdata] = useState({
    name: null,
    phoneNumber: null,
    email: null,
    city: null,
    state: null,
    countryCode: null,
    occupation: null,
    company_name: null,
    linkedin_profile: null,
    dob: null,
    hobbies: null,
    open_to_referral: null,
    ideal_client: null,
    referral_partner: null,
    notes: null,
    is_email: null,
    is_phone_call: null,
    is_sms: null,
    isLinkedin: null,
    profile_image: null,
    cover_image: null,
  });

  useEffect(() => {
    // Get the contact_id from the URL query parameters
    const params = new URLSearchParams(window.location.search);
    const contactId = params.get("contact_id");

    // If the contact_id exists, call the API
    if (contactId) {
      const requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `https://api.followupnowus.com/contacts/get-contact/${contactId}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result); // You can log or handle the result data
          setFormdata(result?.data); // Store the result data in the state
        })
        .catch((error) => console.error("Error fetching contact:", error));
    }
  }, []); // Empty dependency array ensures it only runs once when the component mounts

  const Submit = () => {
    console.log("formData", formData); // Log the current form data
    const params = new URLSearchParams(window.location.search);
    const contactId = params.get("contact_id");

    // Define the request options for submitting the form data
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };

    // Send the POST request to your API
    fetch(
      `https://api.followupnowus.com/contacts/update-contact/${contactId}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((result) => {
        setStep(10);
        console.log("Success:", result); // Handle success response
        // You can navigate to a different step or show a success message
      })
      .catch((error) => {
        console.error("Error submitting form:", error); // Handle errors
        // You might want to display an error message to the user
      });
  };

  const handleNext = (value) => {
    if (value == 1) if (step1status) setStep(1)
    if (value == 2) if (step2status) setStep(2)
    if (value == 3) if (step3status) setStep(3)
    if (value == 4) if (step4status) setStep(4)
    if (value == 5) if (step5status) setStep(5)
    if (value == 6) if (step6status) setStep(6)
    if (value == 7) if (step7status) setStep(7)
    if (value == 8) if (step8status) setStep(8)
    if (value == 9) if (step9status) setStep(9)

  };

  return (
    <>
      <section class="step_wrapper">
        {step === 0 && <Step0 key={formData} setStep={setStep} />}
        {step === 1 && (
          <Step1
            key={formData}
            setStep1Status={setStep1Status}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 2 && (
          <Step2
            setStep2Status={setStep2Status}
            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 3 && (
          <Step3
            setStep3Status={setStep3Status}
            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 4 && (
          <Step4
            setStep4Status={setStep4Status}
            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 5 && (
          <Step5
            key={formData}
            setStep5Status={setStep5Status}

            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 6 && (
          <Step6
            setStep6Status={setStep6Status}

            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 7 && (
          <Step7
            setStep7Status={setStep7Status}

            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 7.1 && formData.is_email && (
          <Step71
            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 7.2 && formData.is_sms && (
          <Step72
            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 7.3 && formData.isLinkedin && (
          <Step73
            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 8 && (
          <Step8
            setStep8Status={setStep8Status}

            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
          />
        )}
        {step === 9 && (
          <Step9
            setStep9Status={setStep9Status}

            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
            Submit={Submit}
          />
        )}
        {step === 10 && <Thankyou />}
        {step === 11 && (
          <NoPage
            key={formData}
            setStep={setStep}
            setFormdata={setFormdata}
            formData={formData}
            Submit={Submit}
          />
        )}

        {step == 0 || step == 10 || step == 11 ? (
          ""
        ) : (
          <div class="bottom_steps">
            <ul class="for_desktop">
              <li
                onClick={() => handleNext(1)}
                className={classNames({ active: step === 1, successfully: step1status })}
              >
                <span>Referrals</span>
              </li>
              <li
                onClick={() => handleNext(2)}
                className={classNames({ active: step === 2, successfully: step2status })}
              >
                <span>Your details</span>
              </li>
              <li
                onClick={() => handleNext(3)}
                className={classNames({ active: step === 3, successfully: step3status })}
              >
                <span>Profession</span>
              </li>
              <li
                onClick={() => handleNext(4)}
                className={classNames({ active: step === 4, successfully: step4status })}
              >
                <span>Ideal Client</span>
              </li>
              <li
                onClick={() => handleNext(5)}
                className={classNames({ active: step === 5, successfully: step5status })}
              >
                <span>Good referral partners</span>
              </li>
              <li
                onClick={() => handleNext(6)}
                className={classNames({ active: step === 6, successfully: step6status })}
              >
                <span>Date of birth</span>
              </li>
              <li
                onClick={() => handleNext(7)}
                className={classNames({ active: step === 7 || step == 7.1 || step == 7.2 || step == 7.3, successfully: step7status })}
              >
                <span>Communication channel</span>
              </li>
              <li
                onClick={() => handleNext(8)}
                className={classNames({ active: step === 8, successfully: step8status })}
              >
                <span>Hobbies</span>
              </li>
              <li
                onClick={() => handleNext(9)}
                className={classNames({ active: step === 9, successfully: step9status })}
              >
                <span>Submit</span>
              </li>
            </ul>
          </div>
        )}
      </section>
      {/* <Step0/> */}
      {/* <Step1/> */}
      {/* <Step2/> */}
      {/* <Step3/> */}
      {/* <Step4/> */}
      {/* <Step5/> */}
      {/* <Step6/> */}
      {/* <Step7/> */}
      {/* <Step71/> */}
      {/* <Step72/> */}
      {/* <Step73/> */}
      {/* <Step8/> */}
      {/* <Step9/> */}
    </>
  );
}

export default App;
